import { defineType } from 'sanity';

export const menuPage = defineType({
    name: 'menu_page',
    title: 'Menu Page',
    type: 'document',
    fields: [
        {
            name: 'domainName',
            title: 'Domain Name',
            type: 'string',
        },
        {
            type: 'grid',
            name: 'menuGrid',
            title: 'Menu Grid',
        },
        {
            name: 'productCardVariant',
            title: 'Product Card Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Classic Card', value: 'A' },
                    { title: 'Horizontal Row', value: 'B' },
                    { title: 'Showcase Card', value: 'C' },
                ],
            },
        },
        {
            name: 'seo',
            title: 'SEO Settings',
            type: 'seo',
            description: 'Search engine optimization settings for better visibility',
        },
        {
            name: 'objectFit',
            title: 'Product Image object fit',
            type: 'string',
            options: {
                list: [
                    { title: 'Contain', value: 'contain' },
                    { title: 'Cover', value: 'cover' },
                    { title: 'Fill', value: 'fill' },
                ],
                layout: 'radio',
            },
        },
    ],
    preview: {
        select: {
            title: 'domainName',
        },
    },
});
